import React from 'react'
import { SizeInputProps } from './types/models'

const SizeInput = ({
  sizeConstraint, unit, value, valid, min, max, step, onSizeChange, onUnitChanged
}: SizeInputProps) => {
  const INITIAL_CLASSES = `customCutting-field cuttingTool-${sizeConstraint.field.toLowerCase()}Field`
  const INVALID_FIELD_CLASS = 'cuttingTool-invalidField'

  return (
    <>
      <div className='sizeInput-wrapper'>
        <input className={`${INITIAL_CLASSES} ${!valid ? INVALID_FIELD_CLASS : ''}`} type='number' data-field={sizeConstraint.field} value={value || ''} step={step} min={min} max={max} autoComplete='off' onChange={onSizeChange} />
        <select className={`cuttingTool-unitField customCutting-${sizeConstraint.field.toLowerCase()}Unit`} data-field={sizeConstraint.field} onChange={onUnitChanged} value={unit}>
          <option value='mm'>mm</option>
          <option value='cm'>cm</option>
          <option value='m'>m</option>
        </select>
      </div>
      <div className='mobile-break'></div>
      {!valid && <>
        <div className={`cuttingTool-${sizeConstraint.field.toLowerCase()}SizeError`}>
          <small>Must be between {min}{unit} and {max}{unit}</small>
        </div>
      </>}
      <div className='spacer'></div>
    </>
  )
}

export default SizeInput
